import React from 'react';
import * as Yup from 'yup';
import kebabcaseKeys from 'kebabcase-keys';
import { authorizedPyInstance as axios } from '~/utils';
import { Link, useHistory } from 'react-router-dom';
import { Button, Form, Field, CardHeader, useSession } from '@cordata/buffet';
import { Card, CardBody } from 'reactstrap';
import { PageLayout, Navbar } from './index';

const options = [
  {
    label: 'Login Assistance',
    value: 'login assistance',
  },
  {
    label: 'Report a Problem',
    value: 'report-a-problem',
  },
  {
    label: 'Request a New Feature',
    value: 'request a new feature',
  },
  {
    label: 'Ask a Product Question',
    value: 'ask a product question',
  },
  {
    label: 'Other Help',
    value: 'other help',
  },
];

const validationSchema = Yup.object().shape({
  userEmail: Yup.string().email().required(),
  issueType: Yup.string().required(),
  comment: Yup.string().required(),
});

const SupportCard = () => {
  const history = useHistory();
  const { current } = useSession();

  return (
    <PageLayout Header={Navbar} title="Customer Support" className="my-4">
      <Card className="my-4">
        <CardHeader>
          While Cordata products and services are easy to use, we understand
          that questions or issues do arise from time to time. To reach our
          technical support team, you can send an email directly to them using
          the form below. Issues are triaged  Monday - Friday 8:00 AM - 5:00 PM EST <br />
          If your issue is urgent, please call 866-396-1445 at any time.
        </CardHeader>
        <CardBody>
          <Form
            validateOnChange
            enableReinitialize
            initialValues={{
              userEmail: current?.attributes?.userEmailAddress,
            }}

            validationSchema={validationSchema}

            onSubmit={(values) => {
              const p = {
                data: {
                  userEmail: values.userEmail,
                  issueType: values.issueType.label,
                  comment: values.comment,
                },
              };
              axios
                .post(
                  '/api/support-request/submit',
                  kebabcaseKeys(p, { deep: true }),
                )
                .then(() => {
                  history.goBack();
                });
            }}
          >
            {({ isSubmitting }) => (
              <>
                <Field
                  name="userEmail"
                  type="email"
                  required
                />
                <Field
                  name="issueType"
                  type="select"
                  options={options}
                  placeholder="Please select a type of Issue"
                  required
                />
                <Field name="comment" type="textarea" label="Comment" required size="lg" />
                <div className="d-flex mt-2">
                  <div className="ml-auto">
                    <Button
                      type="cancel"
                      disabled={isSubmitting}
                      color="tertiary"
                      to="/home"
                      tag={Link}
                    >
                      Cancel
                    </Button>
                    <Button type="submit" disabled={isSubmitting}>
                      Send
                    </Button>
                  </div>
                </div>
              </>
            )}
          </Form>
        </CardBody>
      </Card>
    </PageLayout>
  );
};
export default SupportCard;
